/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.controller('dialog_createPositionCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', 'AtlasDialog', function ($rootScope, $scope, $http, NetworkService, AtlasNotification, AtlasDialog) {
    
        $scope.gui = {};
        $scope.gui.okButtonDisabled = true;
        $scope.position = {};
        $scope.position.adminRequired = true;
        
        $scope.hasValue = function(model){
            return model != undefined && model != "";
        }
        $scope.formChanged = function(){
            if($scope.hasValue($scope.position.Positionsname) && $scope.hasValue($scope.position.Beschreibung)){
                $scope.gui.okButtonDisabled = false;
            }
        }
        
        $rootScope.$on("imageCropped", function(e,data){
            if(data.dataTarget == "dialog_createPositionCtrl"){
                $scope.position.img = data.img
            }
        })
        
        $scope.createPosition = function (){
            var newPosition = {
                name: $scope.position.Positionsname,
                description: $scope.position.Beschreibung,
                eventId: $scope.dialogInitVars.Veranstaltungsnummer,
                adminRequired: $scope.position.adminRequired,
                positionImg: $scope.position.img
            }
            console.log(newPosition);
            
             NetworkService.callOperation("addposition", newPosition, function(d){
                 AtlasNotification.info("Position erfolgreich hinzugefügt.");
                 $rootScope.$emit("updateCalendar")
             })
        }
    }])